import React, { createContext, PropsWithChildren } from 'react';
import { LogglyTracker } from 'loggly-jslogger';
import config from '../config';

class LogglyWrapper {
  // No TS types exist for loggly's JS library yet...
  private readonly logger: any;

  constructor() {
    this.logger = new LogglyTracker();

    this.logger.push({
      logglyKey: config.thirdParty.loggly.token,
      tag: config.thirdParty.loggly.tag,
      sendConsoleErrors: false,
    });
  }

  public log(params: { error?: string, info?: string }) {
    // Only log to Loggly on non-dev environments
    if (import.meta.env.NODE_ENV !== 'development') {
      // eslint-disable-next-line no-console
      console.log('Loggly error', params);
      this.logger.push({ error: params.error, info: params.info });
    }
  }
}

export const logglyLogger = new LogglyWrapper();

// Support for context API in React
const LogglyContext = createContext<LogglyWrapper>(logglyLogger);

export const LoggingProvider: React.FC<PropsWithChildren> = ({ children }) => (
  <LogglyContext.Provider value={logglyLogger}>
    {children}
  </LogglyContext.Provider>
);

const useLoggly = (): LogglyWrapper => React.useContext(LogglyContext);

export default useLoggly;
